import React from "react";

export default function SiteFooter() {
  return (
    <footer
      className="border-t border-[#D9D2C7] mt-24 py-10 px-6"
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-display italic text-[#5C554E] text-sm">
          “Words are the only things that last forever.” — William Hazlitt
        </p>
        <p className="overline" data-testid="footer-credit">
          Hand-set · Adrian's Blog · MMXXVI
        </p>
      </div>
    </footer>
  );
}
